import React, { type JSX } from 'react';

import { Stack, FormHelperText } from '@mui/material';
import { useAppDispatch, useTypedSelector } from '@fiji/common/src/app/store';
import { setUpdateProperties } from '@fiji/common/src/features/deviceManagement/deviceSlice';
import { t } from 'i18next';
import LanguageTextField from 'components/FormElements/LanguageTextField';

export const NameOrDescriptionModal = ({
    type,
    handleTextError,
}: {
    type: string;
    handleTextError?: (hasError: boolean) => void;
}): JSX.Element => {
    const dispatch = useAppDispatch();
    const { propertiesPayload: payload } = useTypedSelector((state) => state.device);
    const maxLength = type === 'name' ? 32 : 256;

    const handleKeyDown = (event: any): any => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    return (
        <>
            <LanguageTextField
                fullWidth
                name={type}
                label={type === 'name' ? t('COMMON:NAME') : t('COMMON:DESCRIPTION')}
                onKeyDown={handleKeyDown}
                inputProps={{ maxLength }}
                value={payload[type]}
                onChange={(e: any): void =>
                    dispatch(setUpdateProperties({ key: e.target.name, value: e.target.value }))
                }
                variant="filled"
                className="margin-top-18"
                {...(type === 'name' && { required: true })}
                id="outlined-required"
                handleTextError={handleTextError}
            />
            <Stack direction={'row'} justifyContent={'flex-end'} px={2}>
                <FormHelperText>{`${payload?.[type]?.length ?? 0}/${maxLength}`}</FormHelperText>
            </Stack>
        </>
    );
};
